import { IBusinessGrossRevenueCapsule, IBusinessGrossRevenueOverview, IBusinessMetricCardConfig } from "./type";
import { ICapsuleData } from "@sg/components/CapsuleBar/type.d";
import { buildUpdateTime, buildPeriod, buildFullYearPeriod, getYearPrefix, roundToDisplayPrecision } from "@sg/utils/common";

export const BUSINESS_GROSS_REVENUE_IEGG_TOTAL = (apiData?: any): ICapsuleData[] => {
  const ytmActual = roundToDisplayPrecision(apiData?.revenue?.total?.ytm_actual);
  const neutralForecast = roundToDisplayPrecision(apiData?.revenue?.total?.full_year_forecast_neutral);
  const businessForecast = roundToDisplayPrecision(apiData?.revenue?.total?.full_year_forecast_business);
  const kpi = roundToDisplayPrecision(apiData?.revenue?.total?.full_year_kpi);
  const yearPrefix = getYearPrefix(apiData?.summary?.revenue?.datatime);

  // Improved rate calculation: check denominator !== 0 and numerator is not null/undefined
  const rateYtm = kpi !== 0 && kpi != null && ytmActual !== null && ytmActual !== undefined
    ? Math.round((ytmActual / kpi) * 100)
    : undefined;
  const rateNeutral = kpi !== 0 && kpi != null && neutralForecast !== null && neutralForecast !== undefined
    ? Math.round((neutralForecast / kpi) * 100)
    : undefined;
  const rateBusiness = kpi !== 0 && kpi != null && businessForecast !== null && businessForecast !== undefined
    ? Math.round((businessForecast / kpi) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: ytmActual,
      rate: rateYtm,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: neutralForecast,
      rate: rateNeutral,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: businessForecast,
      rate: rateBusiness,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isHide: true,
      isBold: true,
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};

export const BUSINESS_GROSS_REVENUE_STUDIO = (apiData?: any): ICapsuleData[] => {
  const ytmActual = roundToDisplayPrecision(apiData?.revenue?.studio.ytm_actual);
  const neutralForecast = roundToDisplayPrecision(apiData?.revenue?.studio.full_year_forecast_neutral);
  const businessForecast = roundToDisplayPrecision(apiData?.revenue?.studio.full_year_forecast_business);
  const kpi = roundToDisplayPrecision(apiData?.revenue?.studio.full_year_kpi);
  const yearPrefix = getYearPrefix(apiData?.summary?.revenue?.datatime);

  const rateYtm = kpi !== 0 && kpi != null && ytmActual !== null && ytmActual !== undefined
    ? Math.round((ytmActual / kpi) * 100)
    : undefined;
  const rateNeutral = kpi !== 0 && kpi != null && neutralForecast !== null && neutralForecast !== undefined
    ? Math.round((neutralForecast / kpi) * 100)
    : undefined;
  const rateBusiness = kpi !== 0 && kpi != null && businessForecast !== null && businessForecast !== undefined
    ? Math.round((businessForecast / kpi) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: ytmActual,
      rate: rateYtm,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: neutralForecast,
      rate: rateNeutral,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: businessForecast,
      rate: rateBusiness,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isHide: true,
      isBold: true,
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};
export const BUSINESS_GROSS_REVENUE_PUBLISHING = (apiData?: any): ICapsuleData[] => {
  const ytmActual = roundToDisplayPrecision(apiData?.revenue?.publishing.ytm_actual);
  const neutralForecast = roundToDisplayPrecision(apiData?.revenue?.publishing.full_year_forecast_neutral);
  const businessForecast = roundToDisplayPrecision(apiData?.revenue?.publishing.full_year_forecast_business);
  const kpi = roundToDisplayPrecision(apiData?.revenue?.publishing.full_year_kpi);
  const yearPrefix = getYearPrefix(apiData?.summary?.revenue?.datatime);

  const rateYtm = kpi !== 0 && kpi != null && ytmActual !== null && ytmActual !== undefined
    ? Math.round((ytmActual / kpi) * 100)
    : undefined;
  const rateNeutral = kpi !== 0 && kpi != null && neutralForecast !== null && neutralForecast !== undefined
    ? Math.round((neutralForecast / kpi) * 100)
    : undefined;
  const rateBusiness = kpi !== 0 && kpi != null && businessForecast !== null && businessForecast !== undefined
    ? Math.round((businessForecast / kpi) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: ytmActual,
      rate: rateYtm,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: neutralForecast,
      rate: rateNeutral,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: businessForecast,
      rate: rateBusiness,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isHide: true,
      isBold: true,
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};

export const BUSINESS_GROSS_REVENUE_CASUAL = (apiData?: any): ICapsuleData[] => {
  const ytmActual = roundToDisplayPrecision(apiData?.revenue?.casual?.ytm_actual);
  const neutralForecast = roundToDisplayPrecision(
    apiData?.revenue?.casual?.full_year_forecast_neutral,
  );
  const businessForecast = roundToDisplayPrecision(
    apiData?.revenue?.casual?.full_year_forecast_business,
  );
  const kpi = roundToDisplayPrecision(apiData?.revenue?.casual?.full_year_kpi);
  const yearPrefix = getYearPrefix(apiData?.summary?.revenue?.datatime);

  const rateYtm =
    kpi !== 0 && kpi != null && ytmActual !== null && ytmActual !== undefined
      ? Math.round((ytmActual / kpi) * 100)
      : undefined;
  const rateNeutral =
    kpi !== 0 &&
    kpi != null &&
    neutralForecast !== null &&
    neutralForecast !== undefined
      ? Math.round((neutralForecast / kpi) * 100)
      : undefined;
  const rateBusiness =
    kpi !== 0 &&
    kpi != null &&
    businessForecast !== null &&
    businessForecast !== undefined
      ? Math.round((businessForecast / kpi) * 100)
      : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: ytmActual,
      rate: rateYtm,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: neutralForecast,
      rate: rateNeutral,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isBold: true,
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: businessForecast,
      rate: rateBusiness,
      type: 'pillar',
      displayTitleFormat: '$,formattedValue, (,rate,%,)',
      isHide: true,
      isBold: true,
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: kpi,
      rate: 100,
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};

// 注意profit相关的不需要rate这个字段，否则在hover的时候就会展示百分比
export const BUSINESS_PROFIT_IEGG_TOTAL = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.datatime);

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.profit?.total.ytm_actual),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: roundToDisplayPrecision(apiData?.profit?.total.full_year_forecast_neutral),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: roundToDisplayPrecision(apiData?.profit?.total.full_year_forecast_business),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isHide: true,
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.profit?.total.full_year_kpi),
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
      zIndex: 100,
    },
    {
      title: '0',
      value: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};

export const BUSINESS_PROFIT_STUDIO = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.datatime);

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.profit?.studio.ytm_actual),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: roundToDisplayPrecision(apiData?.profit?.studio.full_year_forecast_neutral),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: roundToDisplayPrecision(apiData?.profit?.studio.full_year_forecast_business),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isHide: true,
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.profit?.studio.full_year_kpi),
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};

export const BUSINESS_PROFIT_PUBLISHING = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.datatime);

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.profit?.publishing.ytm_actual),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: roundToDisplayPrecision(apiData?.profit?.publishing.full_year_forecast_neutral),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: roundToDisplayPrecision(apiData?.profit?.publishing.full_year_forecast_business),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isHide: true,
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.profit?.publishing.full_year_kpi),
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};

export const BUSINESS_PROFIT_CASUAL = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.datatime);

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.profit?.casual?.ytm_actual),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: roundToDisplayPrecision(
        apiData?.profit?.casual?.full_year_forecast_neutral,
      ),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: roundToDisplayPrecision(
        apiData?.profit?.casual?.full_year_forecast_business,
      ),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isHide: true,
      isBold: true,
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.profit?.casual?.full_year_kpi),
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};

export const BUSINESS_PROFIT_CENTER_CAPABILLITY = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.datatime);

  return [
    {
      title: `${yearPrefix}A`,
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.profit?.capabilities_supporting.ytm_actual),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'skyBlue',
    },
    {
      title: `${yearPrefix}F - Neutral`,
      localeTitleKey: `${yearPrefix}F - Neutral`,
      value: roundToDisplayPrecision(apiData?.profit?.capabilities_supporting.full_year_forecast_neutral),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'purple',
    },
    {
      title: `${yearPrefix}F - Business Team`,
      localeTitleKey: `${yearPrefix}F - Business Team`,
      value: roundToDisplayPrecision(apiData?.profit?.capabilities_supporting.full_year_forecast_business),
      type: 'pillar',
      displayTitleFormat: '$,formattedValue',
      isHide: true,
      isBold: true,
      // titlePosition: 'outside',
      colorType: 'lakeBlue',
    },
    {
      title: `${yearPrefix}B`,
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.profit?.capabilities_supporting.full_year_kpi),
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title,: ,$,formattedValue',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ];
};
export const BUSINESS_OVERALL_GROSS_REVENUE = (apiData?: any): ICapsuleData[] => {
  const revenue25A = roundToDisplayPrecision(apiData?.summary?.revenue?.['25A']);
  const revenue25F = roundToDisplayPrecision(apiData?.summary?.revenue?.['25F']);
  const revenue25B = roundToDisplayPrecision(apiData?.summary?.revenue?.['25B']);
  const yearPrefix = getYearPrefix(apiData?.summary?.revenue?.datatime);

  const rate25A = revenue25B !== 0 && revenue25B != null && revenue25A !== null && revenue25A !== undefined
    ? Math.round((revenue25A / revenue25B) * 100)
    : undefined;
  const rate25F = revenue25B !== 0 && revenue25B != null && revenue25F !== null && revenue25F !== undefined
    ? Math.round((revenue25F / revenue25B) * 100)
    : undefined;

  return [
    {
      title: `${yearPrefix}A`,
      // localeTitleKey: 'dbs_ytm_actual_short', 
      localeTitleKey: `${yearPrefix}A`,
      value: revenue25A,
      rate: rate25A,
      type: 'pillar',
      insideAlign: 'dynamic',
      colorType: 'skyBlue',
      isBold: true
    },
    {
      title: `${yearPrefix}F`,
      // localeTitleKey: 'dbs_full_year_forecast_short', 
      localeTitleKey: `${yearPrefix}F`,
      value: revenue25F,
      colorType: 'purple',
      rate: rate25F,
      type: 'pillar',
      insideAlign: 'dynamic',
      isBold: true,
    },
    {
      title: `${yearPrefix}B`,
      // localeTitleKey: 'dbs_full_year_kpi_short', 
      localeTitleKey: `${yearPrefix}B`,
      value: revenue25B,
      rate: 100,
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
    },
    {
      title: '0',
      value: 0,
      rate: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    }
  ];
};
export const BUSINESS_OVERALL_PROFIT = (apiData?: any): ICapsuleData[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.datatime);

  return [
    {
      title: `${yearPrefix}A`,
      // title: '25A',
      // localeTitleKey: 'dbs_ytm_actual_short',
      localeTitleKey: `${yearPrefix}A`,
      value: roundToDisplayPrecision(apiData?.summary?.profit?.['25A']),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      isBold: true,
      insideAlign: 'dynamic',
      colorType: 'skyBlue'
    },
    {
      title: `${yearPrefix}F`,
      // title: '25F',
      // localeTitleKey: 'dbs_full_year_forecast_short',
      localeTitleKey: `${yearPrefix}F`,
      value: roundToDisplayPrecision(apiData?.summary?.profit?.['25F']),
      type: 'pillar',
      displayTitleFormat: 'title,: ,$,formattedValue',
      isBold: true,
      insideAlign: 'dynamic',
      // titlePosition: 'outside', 
      colorType: 'purple'
    },
    {
      title: `${yearPrefix}B`,
      // title: '25B',
      // localeTitleKey: 'dbs_full_year_kpi_short',
      localeTitleKey: `${yearPrefix}B`,
      value: roundToDisplayPrecision(apiData?.summary?.profit?.['25B']),
      type: 'total',
      markWidth: 2,
      isBold: true,
      titlePosition: 'top',
      colorType: 'orange',
      titleField: 'title',
      markHeight: 40,
      displayTitleFormat: 'title',
      zIndex: 100
    },
    {
      title: '0',
      value: 0,
      type: 'zero',
      markWidth: 2,
      isBold: true,
      titlePosition: 'bottom',
      titleField: 'value',
      markHeight: 40,
      displayTitleFormat: 'formattedValue',
      colorType: 'black',
    },
  ]
};

export const BUSINESS_GROSS_REVENUE_CAPSULE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: 'dbs_iegg_total',
  metrics: BUSINESS_GROSS_REVENUE_IEGG_TOTAL(apiData),
  role: 'parent',
  directionType: 'normal',
}, {
  title: 'dbs_studio',
  metrics: BUSINESS_GROSS_REVENUE_STUDIO(apiData),
  role: 'child',
  directionType: 'normal',
}, {
  title: 'dbs_publishing',
  metrics: BUSINESS_GROSS_REVENUE_PUBLISHING(apiData),
  role: 'child',
  directionType: 'normal',
}, {
  title: 'dbs_casual',
  metrics: BUSINESS_GROSS_REVENUE_CASUAL(apiData),
  role: 'child',
  directionType: 'normal',
}, {
  title: 'dbs_center_capability',
  isDefaultFold: true,
  isOpacity: true,
  group: '1',
  metrics: BUSINESS_PROFIT_CENTER_CAPABILLITY(apiData),
  role: 'child',
  directionType: 'centerInSameDirection',
}];

export const BUSINESS_PROFIT_CAPSULE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: 'dbs_iegg_total',
  metrics: BUSINESS_PROFIT_IEGG_TOTAL(apiData),
  role: 'parent',
  // profit：不管如何，0点都在中间
  directionType: 'centerInSameDirection',
}, {
  title: 'dbs_studio',
  metrics: BUSINESS_PROFIT_STUDIO(apiData),
  role: 'child',
  directionType: 'centerInSameDirection',
}, {
  title: 'dbs_publishing',
  metrics: BUSINESS_PROFIT_PUBLISHING(apiData),
  role: 'child',
  directionType: 'centerInSameDirection',
}, {
  title: 'dbs_casual',
  metrics: BUSINESS_PROFIT_CASUAL(apiData),
  role: 'child',
  directionType: 'centerInSameDirection',
}, {
  title: 'dbs_center_capability',
  isDefaultFold: true,
  metrics: BUSINESS_PROFIT_CENTER_CAPABILLITY(apiData),
  role: 'child',
  group: '1',
  directionType: 'centerInSameDirection',
}];

export const BUSINESS_OVERALL_GROSS_REVENUE_CAPSULE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: BUSINESS_OVERALL_GROSS_REVENUE(apiData),
}];

export const BUSINESS_OVERALL_PROFIT_CAPSULE = (apiData?: any): IBusinessGrossRevenueCapsule[] => [{
  title: '',
  metrics: BUSINESS_OVERALL_PROFIT(apiData),
  // profit：不管如何，0点都在中间
  directionType: 'centerInSameDirection',
}];

export const BUSINESS_GROSS_REVENUE_OVERVIEW = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.revenue?.datatime);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.summary?.revenue?.['25A'] as any,
    ratioUnit: 'YoY',
    ratioValue: apiData?.summary?.revenue?.['25A_yoy']?.toString(),
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.summary?.revenue?.date)
  }, {
    title: `Full Year Neutral Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.summary?.revenue?.['25F'] as any,
    ratioUnit: 'YoY',
    ratioValue: apiData?.summary?.revenue?.['25F_yoy']?.toString() || '0',
    definition: 'dbs_business_full_year_forecast_neutral_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.summary?.revenue?.datatime)
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.summary?.revenue?.['25B'] as any,
    definition: 'dbs_full_year_kpi_definition',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.summary?.revenue?.date)
  }];
};

export const BUSINESS_PROFIT_OVERVIEW = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.date);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.summary?.profit?.['25A'] as any,
    ratioUnit: 'YoY',
    ratioValue: apiData?.summary?.profit?.['25A_yoy']?.toString() || '0',
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.summary?.profit?.date)
  }, {
    title: `Full Year Neutral Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.summary?.profit?.['25F'] as any,
    ratioUnit: 'YoY',
    ratioValue: apiData?.summary?.profit?.['25F_yoy']?.toString() || '0',
    definition: 'dbs_business_full_year_forecast_neutral_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.summary?.profit?.date)
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.summary?.profit?.['25B'] as any,
    definition: 'dbs_full_year_kpi_definition',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.summary?.profit?.date)
  }];
};

export const BUSINESS_OVERALL_GROSS_REVENUE_OVERVIEW = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.revenue?.date);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.summary?.revenue?.['25A'] as any,
    ratioUnit: 'YoY',
    ratioValue: apiData?.summary?.revenue?.['25A_yoy']?.toString() || '0',
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.summary?.revenue?.date)
  }, {
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.summary?.revenue?.['25F'] as any,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.summary?.revenue?.date)
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.summary?.revenue?.['25B'] as any,
    definition: 'dbs_full_year_kpi_definition',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.summary?.revenue?.date)
  }];
};

export const BUSINESS_OVERALL_PROFIT_OVERVIEW = (apiData?: any): IBusinessGrossRevenueOverview[] => {
  const yearPrefix = getYearPrefix(apiData?.summary?.profit?.date);

  return [{
    title: `YTM Actual (${yearPrefix}A)`,
    key: '25A',
    value: apiData?.summary?.profit?.['25A'] as any,
    ratioUnit: 'YoY',
    ratioValue: apiData?.summary?.profit?.['25A_yoy']?.toString() || '0',
    definition: 'dbs_ytm_acutal_definition',
    updateTime: 'dbs_update_time_month',
    source: 'dbs_update_source_finance',
    colorType: 'skyBlue',
    period: buildPeriod(apiData?.summary?.profit?.date)
  }, {
    title: `Full Year Forecast (${yearPrefix}F)`,
    key: '25F',
    value: apiData?.summary?.profit?.['25F'] as any,
    definition: 'dbs_full_year_forecast_definition',
    updateTime: 'dbs_update_time_need',
    source: 'dbs_update_source_finance',
    colorType: 'purple',
    period: buildFullYearPeriod(apiData?.summary?.profit?.date)
  }, {
    title: `Full Year KPI (${yearPrefix}B)`,
    key: '25B',
    value: apiData?.summary?.profit?.['25B'] as any,
    definition: 'dbs_full_year_kpi_definition',
    updateTime: 'dbs_update_time_year',
    source: 'dbs_update_source_finance',
    colorType: 'orange',
    period: buildFullYearPeriod(apiData?.summary?.profit?.date)
  }];
};

export const BUSINESS_TEAM_CHECKBOX: {
  title: string;
  value: string;
}[] = [{
  title: 'dbs_business_team_forecast',
  value: 'businessTeamForecast'
}];

export const COEFFICIENT = 1.1;


export const BUSINESS_GROSS_REVENUE = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_gross_revenue',
  subTitle: buildUpdateTime(apiData?.summary?.revenue?.datatime),
  cards: BUSINESS_GROSS_REVENUE_OVERVIEW(apiData),
  capsule: BUSINESS_GROSS_REVENUE_CAPSULE(apiData)
});

export const BUSINESS_PROFIT = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_profit',
  subTitle: buildUpdateTime(apiData?.summary?.profit?.datatime),
  cards: BUSINESS_PROFIT_OVERVIEW(apiData),
  capsule: BUSINESS_PROFIT_CAPSULE(apiData)
});

export const BUSINESS_OVERALL_GROSS_REVENUE_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_gross_revenue',
  subTitle: buildUpdateTime(apiData?.summary?.revenue?.datatime),
  cards: BUSINESS_OVERALL_GROSS_REVENUE_OVERVIEW(apiData),
  capsule: BUSINESS_OVERALL_GROSS_REVENUE_CAPSULE(apiData),
});

export const BUSINESS_OVERALL_PROFIT_CARD = (apiData?: any): IBusinessMetricCardConfig => ({
  title: 'dbs_profit',
  subTitle: buildUpdateTime(apiData?.summary?.profit?.datatime),
  cards: BUSINESS_OVERALL_PROFIT_OVERVIEW(apiData),
  capsule: BUSINESS_OVERALL_PROFIT_CAPSULE(apiData),
});

// API Response Types - TODO: Settle type definition later
// export interface ExecutiveSummaryApiResponse {
//   period: string;
//   currency: string;
//   summary: {
//     revenue: {
//       [key: string]: number;
//     };
//     profit: {
//       [key: string]: number;
//     };
//   };
//   revenue: {
//     total: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//     studio: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//     publishing: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//     casual: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//   };
//   profit: {
//     total: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//     studio: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//     publishing: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//     casual: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//     capabilities_supporting: {
//       ytm_actual: number;
//       full_year_forecast_neutral: number;
//       full_year_forecast_business: number;
//       full_year_kpi: number;
//     };
//   };
// }
